<template>
  <div>
    <cusDialog :dialogVisible="dialogVisible" :dialogData="dialogData" @close="closeDialog"></cusDialog>
    <!-- 展演入口 -->
    <!-- <div class="container">
      <img :src="showBanner" width="100%" class="pointer" />
    </div> -->
    <br />
    <!-- 展演入口 -->
    <div class="container" v-loading="activeLoading">
      <el-carousel id="el-carousel" style="overflow:hidden">
        <el-carousel-item v-for="(item,index) in activeList" :key="index" class="el-carousel-item">
          <img @click="toUrl(item.url)" ref="image" :src="$imgRoot+'/'+item.image" width="100%" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
      <div>
        <br />
        <div class="container whiteBg newsContainer" v-for="(item,index) in list" :key="index">
          <div class="globalTitle">{{item.name}}</div>
          <br />
          <div class="flex-center-start">
            <div class="newsInfo border">
              <div>
                <!-- 图片轮播 -->
                <el-carousel height="200px" style="width:300px">
                  <el-carousel-item v-for="(imgItem,imgIndex) in item.news.cover" v-if="imgIndex<3" v-show="!empty(imgItem.img)"
                    :key="imgIndex">
                    <img :src="$imgRoot+'/'+imgItem.img" width="100%" height="100%" @click="toDetails(imgItem.nid)" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <!-- 新闻列表 -->
              <div class="newsListContainer">
                <div v-for="(newsItem,newsIndex) in item.news.list" :key="newsIndex" class="pointer"
                  v-show="newsIndex<2" @click="toDetails(newsItem.nid)">
                  <div class="grey newsItemDate">{{newsItem.ctime.split(" ")[0]}}</div>
                  <div class="newsItemTitle" :title="newsItem.title">{{newsItem.title}}</div>
                  <br />
                </div>
                <br />
                <div align="right"><span class="pointer" @click="more(item.themeId)"
                    v-if="item.news.list.length>2">了解更多➡</span></div>
              </div>
            </div>
            <div class="newsRank border">
              <!-- 投稿热度榜 -->
              <div class="whiteBg newsHotContainer">
                <h3>投稿热度榜</h3>
                <hr />
                <div v-if="item.top.length>0">
                  <div v-for="(hotItem,hotIndex) in item.top" :key="hotIndex" v-if="hotIndex<5" class="newsHotItem">
                    <span class="rank"
                      :class="hotIndex==0?'top1':hotIndex==1?'top2':hotIndex==2?'top3':''">{{hotIndex+1}}</span><span
                      class="line1" :title="hotItem.username">{{hotItem.username}}</span>
                  </div>
                </div>
                <div style="padding:10px" v-else>
                  暂无相关信息
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center-start">
            <div class="newsInfo border">
              <div v-for="(tyItem,tyIndex) in item.types" :key="tyIndex" class="flex-around-center processContainer">
                <!-- 投稿流程 -->
                <div class="flex-around-center flex-center-start processIconContainer">
                  <div v-for="(pItem,pIndex) in tyItem.process" :key="pIndex" class="flex-around-center">
                    <div>
                      <div>
                        <!-- <img :src="pItem.icon" width="100px" height="100px" /> -->
                        <img
                          :src="pIndex==0?require('@/assets/tubiao04.png'):pIndex==1?require('@/assets/tubiao05.png'):pIndex==2?require('@/assets/tubiao06.png'):pIndex==3?require('@/assets/tubiao07.png'):pItem.icon" />
                      </div>
                      <br />
                      <div align="center">
                        {{pItem.name}}
                      </div>
                    </div>
                    <div :class="pIndex != tyItem.process.length-1?'':'hide'">
                      <img src="@/assets/tubiao08.png" style="margin-bottom:45px" />
                    </div>
                  </div>
                </div>
                <div class="processBtnContainer">
                  <el-button @click="showDialogVisible(item.themeId,tyItem.typeId)" type="primary">开始投稿</el-button>
                </div>
              </div>
            </div>
            <div class="newsRank border" :style="'height:'+(item.types.length*214-40)+'px;'">
              <!-- 相关附件 -->
              <div class="whiteBg newsHotContainer">
                <h3>相关附件</h3>
                <hr />
                <div v-if="item.files.length>0">
                  <div v-for="(oItem,oIndex) in item.files" :key="oIndex" class="newsOtherItem">
                    <!-- <span class="line1 pointer">{{oItem.name}}</span> -->
                    <a target="_blank" class="line1 pointer" :href="oItem.uri" v-if="oItem.type">{{oItem.name}}</a>
                    <a target="_blank" class="line1 pointer" :href="$imgRoot + oItem.uri" v-else>{{oItem.name}}</a>
                  </div>
                </div>
                <div v-else style="padding:10px">
                  暂无相关附件
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
  import cusDialog from '@/components/dialog'
  export default {
    components: {
      cusDialog
    },
    data() {
      return {
        dialogData: {
          themeName: "",
          themeId: "",
          typeId: "",
          typeName: ""
        },
        activeLoading: true,
        activeList: [],
        dialogVisible: false,
        list: [],
        processList: [],
        showBanner: ""
      }
    },
    mounted() {
      var self = this;
      this.getList();
      this.getActive();
      // window.onresize = function () {
      //   self.height = self.$refs['image'][0].height + "px";
      //   self.resize();
      // }
    },
    methods: {
      resize() {
        var self = this;
        document.getElementById("el-carousel").style.height = self.height;
        let itemList = document.getElementsByClassName("el-carousel-item")
        for (let i = 0; i < itemList.length; i++) {
          itemList[i].style.height = self.height;
        }
      },
      getActive() {
        this.$axios.get("/web/index/active").then(res => {
          if (res.code == 0) {
            this.activeList = res.data;
            this.activeLoading = false;
          }
        })
      },
      getList() {
        var self = this;
        this.$axios.get("/web/index/theme").then(res => {
          if (res.code == 0) {
            this.list = res.data;
            this.list.forEach(val => {
              if (val.files.length == 0) {
                val.files = window.config.fileList;
              }
              if(val.top.length==0){
                val.top = window.config.topList;
              }
            });

            setTimeout(() => {
              self.height = self.$refs['image'][0].height + "px";
              self.resize();
            }, 2000);
          }
        });
      },
      more(themeId) {
        let param = this.encode({
          ntid: themeId
        });
        this.goToPage("News", param);
      },
      showDialogVisible(themeId, typeId) {
        let param = this.encode({
          themeId: themeId,
          typeId: typeId
        })
        this.goToPage("Creat", param);
      },
      toDetails(id) {
        let param = this.encode({
          id: id
        });
        this.goToPage("NewsDetail", param);
      },
      closeDialog() {
        this.dialogVisible = false;
      },
      toUrl(url) {
        if (!this.empty(url)) {
          window.location.href = url;
        }
      }
    }
  }

</script>

<style scoped>
  /* .container {
    display: flex;
    justify-content: center;
    align-content: flex-start;
    margin-top: 25px;
  } */

  .newsContainer {
    margin-top: 25px;
  }

  .title {
    padding: 10px;
  }

  .newsInfo {
    display: inline-flex;
    justify-content: space-between;
    align-content: flex-start;
    background: white;
    padding: 8px;
    width: calc(80% - 14px);
    margin-right: 14px;
    min-height: 214px;
    flex-wrap: wrap;
  }

  .newsRank {
    min-height: 230px;
  }

  .newsRank,
  .newsOtherContainer {
    width: 240px;
    overflow: hidden;
  }

  .newsListContainer {
    width: calc(100% - 320px);
  }

  .newsItemDate {
    margin-bottom: 10px;
  }

  .newsItemTitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .newsHotContainer {
    height: 230px;
    /* margin-bottom: 14px; */
  }

  .newsHotContainer>h3,
  .newsOtherContainer>h3 {
    padding: 8px;
  }

  .newsOtherContainer {
    height: 130px;
  }

  .pointer:hover {
    color: #B41B15;
  }

  .rank {
    display: inline-block;
    background: #999999;
    color: white;
    padding: 1px 5px;
    margin-right: 5px;
  }

  .rank.top1 {
    background: #D82A2A;
  }

  .rank.top2 {
    background: #D89C2A;
  }

  .rank.top3 {
    background: #2F86D8;
  }

  .newsHotItem,
  .newsOtherItem {
    display: inline-flex;
    margin-top: 4px;
    padding: 4px 0;
    margin-left: 12px;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 12px);
  }

  .newsHotItem>.line1,
  .newsOtherItem>.line1 {
    display: inline-block;
    width: calc(100% - 30px);
  }

  hr {
    background: #cccccc;
    border: none;
    height: 1px;
  }

  .more {
    margin: 6px 8px;
  }

  .processContainer {
    width: 100%;
  }

  .processBtnContainer {
    width: 200px;
    margin-bottom: 30px;
  }

  .processIconContainer {
    width: calc(100% - 120px);
    justify-content: flex-start;
  }

  .processIconContainer>.flex-around-center {
    width: 25%;
  }

  .hide {
    opacity: 0;
  }

  .flex-center-start {
    padding: 20px;
  }

  .border {
    border: 1px solid #999999;
  }

  .globalTitle {
    position: absolute;
    background: #B41B15;
    color: white;
    padding: 8px 22px;
    top: -15px;
  }

</style>



// WEBPACK FOOTER //
// src/views/index/components/mainBody.vue